import { useEffect, useState } from 'react';

import { censorCircular } from '@/utils';

import { LOCK_CONTRACT_ADDRESS, LockOption, NetworkKey } from '../constants';
import { useLockContext } from '../LockContext';
import {
  convertDataPoolInfo,
  convertDataPoolInfoWithOraiChain,
  getPoolConfigBatch,
} from './helpers';

export type PoolInfo = {
  id: number;
  label: string;
  totalLock: number;
};

const POOLS = [
  Number(LockOption.ThreeMonths),
  Number(LockOption.SixMonths),
  Number(LockOption.TwelveMonths),
];

const INIT_DATA: PoolInfo[] = [
  {
    id: 0,
    label: '3 Months',
    totalLock: 0,
  },
  {
    id: 1,
    label: '6 Months',
    totalLock: 0,
  },
  {
    id: 2,
    label: '12 Months',
    totalLock: 0,
  },
];

const useTotalLocked = () => {
  const { isRefresh, network } = useLockContext();
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState<PoolInfo[]>(INIT_DATA);

  useEffect(() => {
    if (network === NetworkKey.Bsc) getData();
    else getDataWithOraiChain();
  }, [isRefresh, network]);

  const getData = async () => {
    try {
      setLoading(true);
      const res = await getPoolConfigBatch(LOCK_CONTRACT_ADDRESS[NetworkKey.Bsc], POOLS);
      const dataConvert = convertDataPoolInfo(res);
      setList(dataConvert);
      setLoading(false);
    } catch (error) {
      console.log('err getpoolconfig: ', error);
    }
  };

  const getDataWithOraiChain = async () => {
    try {
      setLoading(true);
      const res = await window.Wasm.query(
        LOCK_CONTRACT_ADDRESS[NetworkKey.Oraichain],
        censorCircular({
          query_pool_config_batch: {
            pool_id: POOLS,
          },
        }),
      );
      const dataConvert = convertDataPoolInfoWithOraiChain(res?.data);
      setList(dataConvert);
      setLoading(false);
    } catch (error) {
      console.log('err getpoolconfig: ', error);
    }
  };

  return { list, loading };
};

export default useTotalLocked;
